<template lang="html">
  <button
    :class="[
             `vs-switch`,
             {
             'vs-switch-active':value
             }
             ]"
    v-bind="$attrs"
    class="vs-component vs-switch">
    <input
      ref="inputCheckbox"
      v-bind="$attrs"
      :disabled="$attrs.disabled"
      :value="value"
      class="input-switch vs-switch--input"
      type="checkbox"
      v-on="listeners">
    <span
      ref="on"
      :class="{'active-text':value }"
      class="text-on text-switch vs-switch--text">
      <slot/>
    </span>
    <span
      ref="off"
      :class="{'active-text':!value}"
      class="text-off text-switch vs-switch--text">
      <slot/>
    </span>
    <span class="vs-circle-switch vs-switch--circle"/>
  </button>
</template>

<script>
import { computed } from 'vue'
import '../assets/vuesax.css'

export default {
  props:{
    value:{
      type: Boolean
    },
    vsValue:{}
  },
  setup(props, context){
    const toggleValue = (evt)=>{
      context.emit('input', !props.value)
      context.emit('change', evt)
    }
    const listeners = computed(()=>({
        ...context.listeners,
        input: toggleValue,
      })
    )
    return {
      listeners
    }
  }
}
</script>

<style lang='scss'>
.v-application{
  &.theme--light{
    .vs-switch{
      background: var(--light-main-bg-color-shade);

      &.vs-switch-active{
        background: var(--light-accent-bg);
        
        svg.iconify path {
          color: var(--dark-icon);
        }
      }
    }
  }
  &.theme--dark .vs-switch--circle,
  &.theme--light .vs-switch--circle{
    background-color: var(--light-main-bg-color)
  }
  &.theme--dark{
    .vs-switch{
      background: var(--dark-main-bg-color-shade);

      &.vs-switch-active{
        background: var(--dark-accent-bg);
      }

      svg.iconify path {
        color: var(--light-text);
      }
    }
  }
  .vs-switch--text.text-off {
    font-size: small;
    filter: invert(1) brightness(0.8);
    padding-right: 0;
    margin-right: 0.2rem
  }
  .vs-switch--text.text-on {
    font-size: small;
    filter: sepia(1) grayscale(.8) ;
    margin-left: 0.2rem;
    padding-left: 0;
  }
  .image-toggle .vs-switch--text.text-off {
    filter: unset;
  }
  .image-toggle .vs-switch--text.text-on {
    filter: unset;
  }
}
</style>
